import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class GlobalActionsAPI extends ComponentAPI {
}
export default GlobalActionsAPI;
//# sourceMappingURL=global-actions-api.js.map